// extracted by mini-css-extract-plugin
export default {"title":"_ab1c16cb"};